export const SET_LOGGED_IN_USER = "SET_LOGGED_IN_USER";
export const SET_CRM_USER = "SET_CRM_USER";
export const REDIRECT_AFTER_LOGIN = "REDIRECT_AFTER_LOGIN";
export const SET_THEME = "SET_THEME";
export const SET_IS_LOADING = "SET_IS_LOADING";
